import React, { useState } from 'react';

import Utils from '@lcsc-ui/utils/Utils';
import { Modal, Input, Button, message } from 'antd';
import styled from 'styled-components';

import { postSelectionCorrectionSave } from '@/apis/selection';

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border: none;
  }
  .ant-modal-body {
    padding-top: 0;
  }
`;

const FeedbackModal = ({ productCode = '', open, onClose }) => {
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!feedback.trim()) {
      message.warning('请输入您的选型意见');
      return;
    }

    if (Utils.isXss(feedback.trim())) {
      message.warning('含非法内容，请修改！');
      return;
    }

    setLoading(true);

    postSelectionCorrectionSave({
      productCode,
      correctionContent: feedback,
    })
      .then((res) => {
        if (res.code === 200) {
          message.success('感谢您的反馈！');
          setFeedback('');
          onClose();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <StyledModal
      title={<span className="text-[16px] font-bold">请提出您的选型意见</span>}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      className="max-w-md"
    >
      <div className="space-y-4">
        <Input.TextArea
          rows={6}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="请输入描述内容"
        />
        <div className="flex justify-end">
          <Button className="w-[90px] h-[32px]" type="primary" onClick={handleSubmit} loading={loading}>
            提交
          </Button>
        </div>
      </div>
    </StyledModal>
  );
};

export default FeedbackModal;
